import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { InvitePage } from "src/app/modules/admin/page/invite/invite.page";

@Injectable()
export class InviteGuard implements CanDeactivate<InvitePage> {
  constructor() { }

  async canDeactivate(
    component: InvitePage,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ) {
    // Observable<boolean|UrlTree>|Promise<boolean|UrlTree>|boolean|UrlTree
    if (!component.hasUnsent && component.confirmLeave) {
      return (await component.confirmLeave() as boolean);
    }
    return true;
  }
}
